module.exports = __webpack_public_path__ + "static/media/step3.d96e84b4.svg";